module.exports = {
	pageLimit: 10,
	userLimit: 180,
	state: {
		active: 'ACTIVE',
		inactive: 'INACTIVE',
	},
};
